const SgiDVEO = function () {
    return {
        te: "我是DV",
        // cId: '222',
        ctlH: '100%',
        ctlW: '100%',
        ctlN: "dv",
        style: { minHeight: '200px' },
        desId: "EP_EO_UI_DV",
        isBrdr: false,
        isHdn: false,
        isScl: false,
        bdInst: '',
        bdDvId: '',
        isTtl: true,
        mgn: "0 0 0 0",
        pad: "0 0 0 0",
        ttlAlgn: "center",
        lblAlgn: "right",
    }
}
export { SgiDVEO };
export default SgiDVEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiDVEO.js